<template>
  <div class="row pt-2">
    <div v-if="(modifiable !== null && modifiable === true)" class="col">
      <Button label="Modifier" v-on:click="modifier"/>
    </div>
    <div class="col">
      <Button label="Audit des modifications" v-on:click="auditModifications"/>
    </div>
    <div v-if="approuvable && this.actionAccesDecision.suiviApprobationActionDecision" class="col">
      <Button label="Approbation" v-on:click="approuver"/>
    </div>
    <div class="col">
      <div class="row">
        <div class="col">
          <Button label="Imprimer" v-on:click="imprimer"/>
        </div>
        <div class="col">
          <Button label="Fermer" v-on:click="fermer"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'ButtonBarSuivi',
  props: ['modifiable', 'approuvable'],
  emits: ['fermer', 'approuver'],
  computed: {
    ...mapGetters({
      actionAccesDecision : 'suivi/actionAccesDecision',
    })
  },
  methods: {
    modifier() {
      this.$router.push({
        name: "modifierSuivi",
        params: {
          cle: this.$route.params.cle,
          site: this.$route.params.site
        },
      });
    },
    imprimer() {
      let routeVersImpressionSuivi = this.$router.resolve({name: 'suiviRapportCDX0097'})
      window.open(routeVersImpressionSuivi.href)
    },
    auditModifications() {
      this.$router.push({
        name: "auditModificationsSuivi",
        params: {
          cle: this.$route.params.cle,
          site: this.$route.params.site
        },
      });
    },
    approuver() {
      this.$emit('approuver');
    },
    fermer() {
      this.$emit('fermer');
    },
  }
}
</script>